export const CM_COLORS = {
  'Mic/Call Station Fault': '#E63946', 'Speaker Cover / Physical': '#F4A261',
  'Amplifier / Fan': '#2A9D8F', 'Controller Error': '#457B9D',
  'PA Communication / Network': '#6D6875', 'Power / Cabling Fault': '#A8DADC',
  'No Fault / User Operation': '#E9C46A', 'System / PA Fault': '#264653', Unclassified: '#ADB5BD',
};
export const FREQUENCIES = { M: 'Monthly', '3M': 'Quarterly (3M)', '6M': 'Half-Yearly (6M)', Y: 'Yearly' };
export const FREQUENCY_COLORS = { Monthly: '#2A9D8F', 'Quarterly (3M)': '#E9C46A', 'Half-Yearly (6M)': '#F4A261', Yearly: '#E76F51' };
export function categorizeFault(description) {
  const d = String(description ?? '').toUpperCase();
  const rules = [
    [['NO FAULT', 'USER ERROR'], 'No Fault / User Operation'],
    [['MIC STATION', 'MICROPHONE', 'CALL STATION'], 'Mic/Call Station Fault'],
    [['COVER', 'DETACH', 'MISALIGN', 'DIRTY', 'RUSTY', 'ALIGNED', 'PHYSICAL', 'STAIN'], 'Speaker Cover / Physical'],
    [['POWER CONNECTION', 'POWER CORD'], 'Power / Cabling Fault'],
    [['FAN', 'COOLING', 'LINE CARD'], 'Amplifier / Fan'],
    [['CONTROLLER'], 'Controller Error'],
    [['COMMUNICATION', 'NETWORK', 'DROPOUT', 'IT ISSUE', 'ANNOUNCEMENT', 'INCOMPLETE', 'DISCONNECTED'], 'PA Communication / Network'],
    [['NOT WORKING', 'FAULTY', 'PA SYSTEM', 'VOLUME', 'NOISY', 'NOISE', 'PUBLIC ADDRESS'], 'System / PA Fault'],
  ];
  return rules.find(([words]) => words.some((w) => d.includes(w)))?.[1] || 'Unclassified';
}
export function frequency(code) {
  const prefix = String(code ?? '').trim().toUpperCase().split('-')[0];
  return FREQUENCIES[prefix] || prefix;
}
const counts = (rows, key) => {
  const map = new Map();
  rows.forEach((r) => { const k = key(r); map.set(k, (map.get(k) || 0) + 1); });
  return [...map].sort((a, b) => b[1] - a[1]);
};
export function analyzeMaintenance(data) {
  const metrics = (rows) => [rows.length, new Set(rows.map((r) => r.date).filter(Boolean)).size, new Set(rows.map((r) => r.location)).size];
  const daily = (rows) => counts(rows.filter((r) => r.date), (r) => r.date).sort((a, b) => a[0].localeCompare(b[0]));
  const order = Object.values(FREQUENCIES);
  const rank = (v) => order.includes(v) ? order.indexOf(v) : order.length;
  return { month: data.month, cmMetrics: metrics(data.cm), pmMetrics: metrics(data.pm),
    categories: counts(data.cm, (r) => categorizeFault(r.description)), locations: counts(data.cm, (r) => r.location).slice(0, 10),
    cmDaily: daily(data.cm), pmDaily: daily(data.pm),
    frequencies: counts(data.pm, (r) => frequency(r.activityCode)).sort((a, b) => rank(a[0]) - rank(b[0]) || a[0].localeCompare(b[0])),
  };
}

// Preserve the System Report analyzer's field contract and optional export columns.
export function toSystemRecords(data) {
  const rawFields = (r) => Object.fromEntries(Object.entries(r.raw).map(([k, v]) => [k, String(v ?? '').trim()]));
  return {
    cmRecords: data.cm.map((r) => ({ ...rawFields(r), wo_no: r.workOrder, received_date: r.date || '', fault_description: r.description, location: r.location, remarks: r.remarks, status: r.status })),
    pmRecords: data.pm.map((r) => ({ ...rawFields(r), work_order: r.workOrder, scheduled_date: r.date || '', activity_code: r.activityCode, contractor_location: r.location, status: r.status })),
  };
}
